import React from 'react';


export default function Photo(props)
{
	const style = {
		pointerEvents: props.pointerEvents ? props.pointerEvents : "none",
	}

	//render
	return (
		<button className='checklistPreviewButton' style={style} onClick={(e)=>
		{
			if(props.onChangeCallback)
			{
				props.onChangeCallback('photo taken');
			}
		}}>Take Photo</button>
	)
}